import React, { useState } from "react";

import Layout from "../components/Layout";
import SEO from "../components/SEO";

import { firestore } from "gatsby-theme-firebase";
import { openPopupWidget } from "react-calendly";

const CalendlyButton = ({ text, url }) => {
  const onClick = () => openPopupWidget({ url });

  return <button className="text-indigo-600 font-semibold" onClick={onClick}>{text}</button>;
};

function ContactPage() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = event => {
    event.preventDefault();
    // add to firestore
    firestore.collection("emails").add({
      email: email,
      message: message,
      name: name
    })
      .then(function (docRef) {
        setEmail('');
        setName('');
        setMessage('');
        alert("Message sent successfully!");
        setTimeout(window.location.reload(), 1500);
      })
      .catch(function (error) {
        // console.error("Error adding document: ", error);
      });
  }


  return (
    <Layout>
      <SEO title="Contact" />
      <section>
        <form className="w-full px-8 pt-2 pb-16 mx-auto md:w-1/2" onSubmit={handleSubmit}>
          <h1 className="mb-8 leading-loose font-extrabold text-4xl text-center">
            Contact Us
          </h1>
          <p className="text-xl text-center pb-8 md:text-2xl lg:text-3xl text-gray-700">
            Please send us a message and I will get back to you within 1 business day
          </p>
          <label
            className="block mb-2 text-xs font-bold uppercase"
            htmlFor="first-name"
          >
            Name
          </label>

          <input
            className="w-full mb-6 form-input"
            id="name"
            placeholder="Bill Gates"
            type="text"
            onChange={(e) => setName(e.target.value)}
          />

          <label
            className="block mb-2 text-xs font-bold uppercase"
            htmlFor="email"
          >
            Email
          </label>

          <input
            className="w-full mb-6 form-input"
            id="last-name"
            placeholder="billgates@microsoft.com"
            type="text"
            onChange={(e) => setEmail(e.target.value)}
          />

          <label
            className="block mb-2 text-xs font-bold uppercase"
            htmlFor="message"
          >
            Message
          </label>

          <textarea
            className="w-full mb-6 form-textarea"
            id="message"
            placeholder="Say something..."
            rows="8"
            onChange={(e) => setMessage(e.target.value)}
          />

          <button type="submit" className="px-4 py-2 text-lg font-medium text-white bg-indigo-600 rounded hover:border-indigo-700 hover:bg-indigo-700">
            Submit
          </button>
        </form>
        <p className="text-xl text-center pb-16 px-4 max-w-2xl mx-auto md:text-2xl lg:text-3xl text-gray-700">
          Or if you want to talk about your project in detail you can <CalendlyButton text="book a call" url="https://calendly.com/bilaltahir89/intro-call" /> with me.
        </p>
      </section>
    </Layout>
  );
}

export default ContactPage;
